import Swal from "sweetalert2";
import { api } from "../api/Middleware";
import { AI_AGENTS_URL, AI_URL, WABOTTY_URL } from "../api/Urls";
import { ERROR_MESSAGES } from "../helpers/ErrorMessages";

export const GetAccount = async (b_token) => {
  try {
    let response = await api.get(
      `${WABOTTY_URL}get_accounts/?b_token=${b_token}`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const SyncActions = async (payload) => {
  try {
    let response = await api.post(`${WABOTTY_URL}sync_actions/`, payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const ConnectWhatsappAccount = async (params) => {
  try {
    let response = await api.post(`${WABOTTY_URL}connect_account/`, params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};
export const ReconnectWhatsappAccount = async (params) => {
  try {
    let response = await api.post(`${WABOTTY_URL}reconnect_account/`, params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};
export const GetWhatsappQrCode = async (data) => {
  try {
    let response = await api.post(`${WABOTTY_URL}generate_qr_code/`, data, {
      responseType: "arraybuffer",
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const GetTemplates = async (params) => {
  try {
    let response = await api.get(`${WABOTTY_URL}get_templates/` + params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const PauseOrActiveAccount = async (data) => {
  try {
    let response = await api.post(
      `${WABOTTY_URL}pause_or_active_account/`,
      data
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const DeleteAccount = async (data) => {
  try {
    let response = await api.post(`${WABOTTY_URL}delete_account/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const AddAutoReply = async (payload, setNotify) => {
  try {
    let formData = new FormData();

    // Preenche o FormData com os dados
    for (let key in payload) {
      if (key === "media") {
        formData.append("file", payload.media); // arquivo no campo "file"
      } else {
        formData.append(key, payload[key]);
      }
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await api.post(
      `${WABOTTY_URL}add_auto_reply/`,
      formData,
      config
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar resposta automática", error);
    if (setNotify) {
      setNotify({
        title: "Erro!",
        message: "Erro ao cadastrar resposta automática.",
        type: "danger",
        visible: true,
      });
    }
  }
};

export const UpdateAutoReply = async (payload, setNotify) => {
  try {
    let formData = new FormData();

    // Preenche o FormData com os dados
    for (let key in payload) {
      if (key === "media") {
        formData.append("file", payload.media); // arquivo no campo "file"
      } else {
        formData.append(key, payload[key]);
      }
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await api.put(
      `${WABOTTY_URL}update_auto_reply/`,
      formData,
      config
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar resposta automática", error);
    if (setNotify) {
      setNotify({
        title: "Erro!",
        message: "Erro ao atualizar resposta automática.",
        type: "danger",
        visible: true,
      });
    }
  }
};

export const DeleteActionBulk = async (uid, data, setNotify) => {
  try {
    let ids = [];
    data.map((action) => ids.push(action.id));

    let response = await api.delete(WABOTTY_URL + "delete_actions_bulk/", {
      data: { uid: uid, ids: ids },
    });
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Operação realizada com sucesso!",
        type: "success",
        visible: true,
      });
      return true;
    }
  } catch (error) {
    console.log(error);
    //if(error.status !== 401) throw error.response;
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
  }
};

export const UpdateTemplate = async (params, setNotify) => {
  try {
    let response = await api.put(`${WABOTTY_URL}update_template/`, params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
    return false;
  }
};

export const UpdateAiAgentData = async (params, setNotify) => {
  try {
    let response = await api.put(`${WABOTTY_URL}update_agent_data/`, params);
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Agente atualizado com sucesso!",
        type: "success",
        visible: true,
      });
      return true;
    }
  } catch (error) {
    setNotify({
      title: "Oops!",
      message:
        error?.response?.data?.error ||
        "Ocorreu um erro, por favor, tente novamente em alguns minutos. Se o erro persistir, contacte nosso suporte.",
      type: "error",
      visible: true,
    });
    return false;
  }
};

export const GetAgentsData = async (page = 1, pageSize = 10, search = "") => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
    });

    if (search) {
      params.append("search", search);
    }

    let response = await api.get(`${AI_AGENTS_URL}?${params}`);
    if (response.status === 200) {
      return response.data.results;
    }
  } catch (error) {
    throw error.response;
  }
};

// Atualizar API Key do agente
export const UpdateAgentApiKey = async (agentId, apiKey, setNotify) => {
  try {
    let response = await api.patch(
      `${AI_AGENTS_URL}${agentId}/update_api_key/`,
      {
        api_key: apiKey,
      }
    );
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: "API Key atualizada com sucesso!",
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message: error?.response?.data?.error || "Erro ao atualizar API Key",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Atualizar status do agente (ativo/inativo)
export const UpdateAgentStatus = async (agentId, isActive, setNotify) => {
  try {
    let response = await api.patch(
      `${AI_AGENTS_URL}${agentId}/update_status/`,
      {
        is_active: isActive,
      }
    );
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: `Agente ${isActive ? "ativado" : "desativado"} com sucesso!`,
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao atualizar status do agente",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Atualizar versão ativa do agente
export const UpdateAgentVersion = async (agentId, versionActive, setNotify) => {
  try {
    let response = await api.patch(
      `${AI_AGENTS_URL}${agentId}/update_version/`,
      {
        version_active: versionActive,
      }
    );
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: `Versão alterada para v.${versionActive} com sucesso!`,
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao atualizar versão do agente",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Buscar versões disponíveis do agente
export const GetAgentVersions = async (agentId) => {
  try {
    let response = await api.get(
      `${AI_AGENTS_URL}${agentId}/available_versions/`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Preparar agente para teste
export const PrepareAgentForTest = async (agentId, setNotify) => {
  try {
    let response = await api.get(`${AI_AGENTS_URL}${agentId}/test_agent/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao preparar agente para teste",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Buscar estatísticas do agente
export const GetAgentStats = async (agentId) => {
  try {
    let response = await api.get(`${AI_AGENTS_URL}${agentId}/stats/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Registrar cópia do prompt (para analytics)
export const RegisterPromptCopy = async (agentId) => {
  try {
    let response = await api.post(`${AI_AGENTS_URL}${agentId}/copy_prompt/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    // Não lançar erro aqui, pois é apenas para analytics
    return false;
  }
};

// Criar nova versão do agente
export const CreateAgentVersion = async (agentId, setNotify) => {
  try {
    let response = await api.post(`${AI_AGENTS_URL}${agentId}/create_version/`);
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: "Nova versão criada com sucesso!",
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao criar nova versão do agente",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Exportar versão específica do agente
export const ExportAgentVersion = async (agentId, version = null) => {
  try {
    const params = version ? `?version=${version}` : "";
    let response = await api.get(
      `${AI_AGENTS_URL}${agentId}/export_version/${params}`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Buscar todas as versões do agente
export const GetAgentVersionHistory = async (agentId) => {
  try {
    let response = await api.get(`${AI_AGENTS_URL}${agentId}/versions/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Buscar detalhes de uma versão específica
export const GetAgentVersionDetail = async (agentId, version) => {
  try {
    let response = await api.get(
      `${AI_AGENTS_URL}${agentId}/version_detail/?version=${version}`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Ativar/desativar agente (método alternativo)
export const ToggleAgentStatus = async (agentId, setNotify) => {
  try {
    let response = await api.post(`${AI_AGENTS_URL}${agentId}/activate/`);
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: response.data.message,
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao alterar status do agente",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

export const CreateUser = async (data) => {
  try {
    let response = await api.post(WABOTTY_URL, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const ActiveBot = async (data) => {
  try {
    let response = await api.post(`${WABOTTY_URL}active_bot/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const PauseBot = async (data) => {
  try {
    let response = await api.post(`${WABOTTY_URL}pause_bot/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const ChangeBotStatus = async (data, setShowModal, loadColumns) => {
  try {
    let response = await api.post(`${AI_URL}enable_or_disable/`, data);
    
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error)
    if (error.response.status === 404) {
      Swal.fire({
        icon: "info",
        title: "Atenção!",
        html: `Este contato ainda não esta cadastrado, deseja cadastrá-lo agora?`,
        showCancelButton: true,
        confirmButtonColor: "var(--primary)",
        cancelButtonColor: "var(--subtitles)",
        confirmButtonText: "Cadastrar agora",
        cancelButtonText: "Cancelar",
      }).then((value) => {
        if (value.isConfirmed) {
          if (setShowModal && loadColumns) {
            setShowModal(true);
            loadColumns();
          }
        }
      });
    } else {
      Swal.fire(
        "Oops!",
        "Ocorreu um erro inesperado! Por favor, tente novamente ou entre em contato com nosso suporte.",
        "error"
      );
    }
  }
};

export const GetContacts = async (page = 1, phone = false) => {
  try {
    let response = await api.get(
      `${WABOTTY_URL}get_contacts/?page=${page}${
        phone ? `&phone=${phone}` : ""
      }`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const SearchContact = async (phone) => {
  try {
    let response = await api.get(
      `${WABOTTY_URL}search_contact/?phone=${phone}`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const UpdateContactName = async (payload) => {
  try {
    let response = await api.put(`${WABOTTY_URL}update_contact_name/`, payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};
